import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AuthService} from '../../shared/services/auth/auth.service'
import {AssociateService} from '../../shared/services/associate.service'
import {WorkgroupService} from '../workgroup-services/workgroup.service'
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import * as moment from 'moment'
import {Sort, MatDialog} from '@angular/material';
import { MobileFilterComponent } from '../../shared/components/mobile-filter/mobile-filter.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
  public isMobileView = false;
  public isLoading: Boolean = false;
  // variable
  public panelOpenState=false;

  public groups:any=[];
  public search:String="";
  public approved:boolean=true;
  public pending:boolean=true;
  public myWorkgroup:boolean=false;
  public approve=[];
  public isPrivate:Boolean = false;
  public isManager:Boolean=false;
  public associate:any;
  public startDate: any ;
  public endDate :Date;
  public groupStatus:any = "";
  public length = 100;
  public pageSize = 15;
  public pageindex=0;
  public privateGroups:any=[];
  public pageSizeOptions = [ 5, 10, 15, 25, 50, 100];
  public isSearch=true;
  public sort:any = {'groupAlias':1}
  constructor(
    public dialog: MatDialog,
    public _router:Router,
    public route:ActivatedRoute,
    public auth:AuthService,
    public associateService:AssociateService,
    public workGroupService:WorkgroupService,
    public mobileNav: MobileNavService
  ) { }

  ngOnInit() {
    console.log(this.auth.user)
    if (window.innerWidth < 768 ) { 
      this.isMobileView = true;
    }
    if (this.auth.user.role=='Admin' || this.auth.user.role=='Super Admin' || this.auth.user.role=='OpCo Manager' ||
     this.auth.user.role=='HR Manager' || this.auth.user.role=="Marcom Manager")
        {
          this.isManager=true;
        }

    this.associateService.getAssociate(this.auth.user.associateId).subscribe(res=>{
      this.associate=res['data'][0];
      this.workingGroupSearch(); 
      if(this.associate)
        this.privateWorkroups(); 
      });
    // this.isManager=false;
  }

  onClickMe() {
    this.mobileNav.showSideNav();
 }

  getServerData(event) {
    this.isSearch = false;
    this.pageindex = event.pageIndex;  
    this.pageSize = event.pageSize;
    this.workingGroupSearch();
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
  }

  privateWorkroups(){
    if(!this.associate){
      return;
    }
    var pgroup = this.associate.workGroupsAndCommittees.filter(x => {
      if(this.startDate && this.endDate){
        // tslint:disable-next-line:max-line-length
        if (x.alias.toLowerCase().includes(this.search.toLowerCase()) && moment(x.startDate) >= moment(this.startDate) && moment(x.endDate) <= moment(this.endDate) ){
          return x;
        }
      }else if(this.startDate) {
        if (x.alias.toLowerCase().includes(this.search.toLowerCase()) && moment(x.startDate) >= moment(this.startDate)){
          return x;
        }
      }else if(this.endDate){
        if (x.alias.toLowerCase().includes(this.search.toLowerCase()) &&  moment(x.endDate) <= moment(this.endDate)){
          return x;
        }  
      }else{
        if (x.alias.toLowerCase().includes(this.search.toLowerCase())){
          return x;
        }  
      }
    })

    if(this.isPrivate){
      pgroup = pgroup.filter(x => {
        if(x.privacy == 'Private')
          return x;
      });
    }

    if(this.isManager){      
      if(this.approved && this.pending){
        pgroup = pgroup.filter(x => {
          if(x.approval == 'Approved' || x.approval == 'pending')
            return x;
        });
      }else if(this.pending){
        pgroup = pgroup.filter(x => {
          if(x.approval == 'pending')
            return x;
        });
      }else if(this.approved){
        pgroup = pgroup.filter(x => {
          if( x.approval == 'Approved')
            return x;
        });
      }
      
    }

  pgroup = pgroup.filter(x => {
    if (this.groupStatus === "") {
      return x
    }else if (this.groupStatus === x.status) {
      return x;
    }
  });

    this.length = pgroup.length;
    pgroup = pgroup.slice(this.pageSize * this.pageindex, this.pageSize * this.pageindex + this.pageSize);
    if (this.isMobileView && !this.isSearch) {
      this.privateGroups = this.privateGroups.concat(pgroup);
    } else {
      this.privateGroups = pgroup;
    }
    this.privateGroups =  this.privateGroups.sort((a, b) => {this.compare(a.alias.toLowerCase(), b.alias.toLowerCase(), true)});
  } 

  workingGroupSearch() {
    this.length = 0;
    this.approve = [];
    if (this.isManager) {
      if (this.approved) {
        this.approve.push('Approved')
      }
      if (this.pending){
        this.approve.push('pending')
      }
    }else if (!this.isManager) {
      this.approve = ['Approved']
    }
    if(this.myWorkgroup || this.isPrivate){
      this.privateWorkroups();
      return;
    }
    if (this.isSearch) {
      this.pageindex = 0;
    }

    if (this.isManager && !this.myWorkgroup) {
      this.isLoading = true;
      this.workGroupService.getWorkGroupFiltered( this.search, this.pageSize, this.pageindex, this.startDate,
        this.endDate, this.groupStatus,this.sort, this.approve).subscribe( (data) => {
          console.log('data 1',data)
        this.isLoading = false;
        if (this.isMobileView && !this.isSearch) {
          this.groups = this.groups.concat(data['data']);
        } else {
          this.groups = data['data'];
        }
          this.length = data['length'];
          const sorted =  this.groups.sort((a, b) => {this.compare(a.groupAlias.toLowerCase(), b.groupAlias.toLowerCase(), true)});
          this.groups = sorted;
          this.isSearch = true;
      }, (error) => {
        this.isLoading = false;
        this.isSearch = true;
        console.log(error);
      } );
    }else {
      this.isLoading = true;
      this.workGroupService.getWorkGroupFiltered(this.search, this.pageSize, this.pageindex, this.startDate,
        this.endDate, this.groupStatus,this.sort,this.approve, 'Public').subscribe( (data) => {
          console.log('data 2',data)
        this.isLoading = false;
        if (this.isMobileView && !this.isSearch) {
          this.groups = this.groups.concat(data['data']);
        } else {
          this.groups = data['data'];
        }
        this.length = data['length'];
        const sorted =  this.groups.sort((a, b) => {this.compare(a.groupAlias.toLowerCase(), b.groupAlias.toLowerCase(), true)});
        this.groups = sorted;
    }, (error) => {
        this.isLoading = false;
        console.log(error);
      })
    }
  }




  sortData(sort: Sort) {
    let data;
    if (this.myWorkgroup){
      data = Object.assign([], this.privateGroups);
    }else{
      data = Object.assign([], this.groups);
    }

    if (!sort.active || sort.direction == '') {
      this.privateGroups = data;
      return;
    }
    let isAsc = sort.direction == 'asc';
    var sortedGroup = data.sort((a, b) => {
      if (this.myWorkgroup){
        switch (sort.active) {
          case 'name': return this.compare(a.alias.toLowerCase(), b.alias.toLowerCase(), isAsc);
          case 'scope': return this.compare(a.scope.toLowerCase(), b.scope.toLowerCase(), isAsc);
          case 'type': return this.compare(a.groupType.toLowerCase(), b.groupType.toLowerCase(), isAsc);
          case 'members': return this.compare(a.membersCount, b.membersCount, isAsc);
          case 'startDate': return this.compare(a.startDate, b.startDate, isAsc);
          case 'endDate': return this.compare(a.endDate, b.endDate, isAsc);
          case 'status': return this.compare(a.status.toLowerCase(), b.status.toLowerCase(), isAsc);
          default: return 0;
        }
      } else {
        this.sort = {};
        this.sort[sort.active] = isAsc ? 1 : -1;
        this.workingGroupSearch();
        // switch (sort.active) {
        //   case 'name': return this.compare(a.groupAlias.toLowerCase(), b.groupAlias.toLowerCase(), isAsc);
        //   case 'scope': return this.compare(a.scope.toLowerCase(), b.scope.toLowerCase(), isAsc);
        //   case 'type': return this.compare(a.groupType.toLowerCase(), b.groupType.toLowerCase(), isAsc);
        //   case 'members': return this.compare(a.Members.length, b.Members.length, isAsc);
        //   case 'startDate': return this.compare(a.startDate, b.startDate, isAsc);
        //   case 'endDate': return this.compare(a.endDate, b.endDate, isAsc);
        //   case 'status': return this.compare(a.groupStatus.toLowerCase(), b.groupStatus.toLowerCase(), isAsc);
        //   default: return 0;
        // }        
      }
    });
    if (this.myWorkgroup){
      this.privateGroups = sortedGroup;
    } else {
      this.groups = sortedGroup;
    }
  }
  
  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }  
  onClickFilter(){
    let dialogRef = this.dialog.open(MobileFilterComponent, {
        width: '300px',
        data: {type:'workgroup' , startDate: this.startDate, endDate: this.endDate, 
        myWorkgroup: this.myWorkgroup, groupStatus: this.groupStatus, pending:this.pending , 
        approved: this.approved, isPrivate :this.isPrivate}
      });

    dialogRef.afterClosed().subscribe(res => {
      if (res !== undefined) {
        this.startDate = res.startDate;
        this.endDate = res.endDate;
        this.myWorkgroup = res.myWorkgroup;
        this.approved = res.approved;
        this.pending = res.pending;
        this.groupStatus = res.groupStatus;
        this.isPrivate = res.isPrivate;
        this.isSearch = true;
        this.workingGroupSearch();
      }
    });
  }
  mobileRouting(url,id){
    if(window.innerWidth < 600){
        this._router.navigate([url,id]);
    }
}
// scroll for mobile screen
@HostListener('window:scroll', ['$event']) onScrollEvent($event) {
  if (window.innerWidth < 768 ) {
      let h = document.documentElement,
      b = document.body,
      st = 'scrollTop',
      sh = 'scrollHeight';
      var percent = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;
      if (percent === 100) {
        console.log('Scroll 11');
        this.pageindex++;
        this.isSearch = false;
        console.log('Page Index', this.pageindex);
        this.workingGroupSearch();
          //this.getAssociatesMobile(this.pageIndex);
      }
  }
}
}
